import Link from "next/link";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { switchNetworkModalHide } from "../../redux/marketplaceSlice";
import { Confirm_checkout } from "../metamask/Metamask";
import { WalletConnectButton } from "@sei-js/react";

const SwitchNetworkModal = () => {
  const { switchNetworkModal } = useSelector((state) => state.marketplace);
  const dispatch = useDispatch();

  return (
    <div>
      {/* <!-- Buy Now Modal --> */}
      <div
        className={switchNetworkModal ? "modal fade show block" : "modal fade"}
      >
        <div className="modal-dialog max-w-2xl min-w-[500px]">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="buyNowModalLabel">
                Connect the wallet
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => dispatch(switchNetworkModalHide())}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                </svg>
              </button>
            </div>
            <div className="modal-body flex items-center justify-center gap-4 p-4">
              <div className="w-[140px] cursor-pointer h-[140px] flex items-center justify-center rounded-md border-2 border-white">
                phantom
              </div>
              <div className="w-[140px] cursor-pointer h-[140px] flex items-center justify-center rounded-md border-2 border-white">
                <WalletConnectButton buttonClassName="js-wallet w-[140px] h-[40px] text-base border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent flex  items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwitchNetworkModal;
